import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject } from 'rxjs';
import { UserPrivileges, UserRoleConstants } from 'src/app/constants/AppConstants';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CommonServiceService } from 'src/app/services/common-service.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-blocked-plots',
  templateUrl: './blocked-plots.component.html',
  styleUrls: ['./blocked-plots.component.scss']
})
export class BlockedPlotsComponent implements OnInit {

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  blockedPlots: any = [];
  userInfo: any;
  popup = true;
  unBlockingPlot: any;
  closeResult = '';
  error: boolean;
  errorMessage: any;
  ventureId: any;

  constructor(
    private restService: RestService,
    public commonService: CommonServiceService,
    private authService: AuthServiceService,
    private modalService: NgbModal,
    private permissionsService: NgxPermissionsService
    ) { }

  ngOnInit(): void {

    this.ventureId = this.commonService.getVenture()?.ventureId;

    this.fetchBlockedPlots();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      bPaginate: false,
      bInfo: false,
      searching: false,
    };
    
  }


  fetchBlockedPlots(){

    this.userInfo = this.authService.getUserInfo();

    let url;

    if(this.userInfo.scopes.includes('TENANT_PRIVILEGE') || this.userInfo.scopes.includes('TENANT_BASIC_PRIVILEGE')) {
      url = 'tenant/get-blocked-plots?ventureId=' + this.ventureId;
    } else if(this.userInfo.scopes.includes('MARKETER_SUPER_PRIVILEGE') || this.userInfo.scopes.includes('MARKETER_BASIC_PRIVILEGE')) {
      url = 'marketer/get-blocked-plots?ventureId=' + this.ventureId;
  }

  this.dtTrigger.next();
    this.restService.getBlockedPlots(url).subscribe(response => {
      if (response != null && response != undefined) {
        this.blockedPlots = response.data;

        if (this.authService.hasRole(UserRoleConstants.MARKETER)) {
          this.permissionsService.hasPermission(UserPrivileges.MARKETER_SUPER_PRIVILEGE).then(hasMarketerSuperPrivilege => {
            if (hasMarketerSuperPrivilege) {
              this.popup = false;      
            }
          });
          this.permissionsService.hasPermission(UserPrivileges.MARKETER_BASIC_PRIVILEGE).then(hasMarketerBasicPrivilege => {
            if (hasMarketerBasicPrivilege) {
              this.popup = false;       
            }
          });
        }

      }
    },
    (error) => {
      console.log(error.status);
    });
  }

  capitalFirst(type) {
    const mySentence = type;
    return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }

  open(content, plot) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.unBlockingPlot = plot;
  }

  private getDismissReason(reason: any): string {

    return `with: ${reason}`;

  }

  unBlockPlot() {
    const requestData = {
      plotId: this.unBlockingPlot.plotId
    };
    this.restService.unBlockPlot(requestData).subscribe((response) => {
        this.modalService.dismissAll();
        this.fetchBlockedPlots();
    },
      (error) => {
        this.error = true;
        this.errorMessage = error.status;
      });
  }

}
